<template>
  <div>
    <page-heading-info
    title="Jefferson County Tax Sales"
    ></page-heading-info>

    <div class="overflow-hidden">
      <div class="row ">
        <div class="col-md-6 mt-3">
					<div class="mb-4 p-2 bg-grey-02">
        <p>
            If you have questions about any upcoming tax sale, call the Jefferson County Prosecutor’s office at <span class="text-bold">(740) 283-1966 ext. 114</span>. 
          </p>
          <p>
            If you have questions regarding your tax bill or payments, or if you want to request that a delinquent parcel be 
            included in a future tax sale, please contact the Jefferson County Treasurer's office at <span class="text-bold">(740) 283-8572</span>.
          </p>
          <div class="text-bold font-size-15 mb-3">
            <!--<p>Treasurer Sale November 22, 2024 & December 13, 2024</p>-->
            <note-text note-id="37"></note-text>
          </div>
        </div>
        <div class="col-md-6 mt-3">
				</div>
      </div>
    </div>

    <text-box-title title="Jefferson County Tax Sale Documents">
      <note-documents note-id="1" class="ml-3 mr-3 mt-3"></note-documents>
    </text-box-title>

  </div>
  </div>
</template>

<script>
import NoteDocuments from '@/components/display-utils/NoteDocuments'
import NoteText from '@/components/display-utils/NoteText.vue'
import PageHeadingInfo from '@/components/layout/PageHeadingInfo'
import TextBoxTitle from '@/components/layout/TextBoxTitle'
import TextBox from '@/components/layout/TextBox'

export default {
  components: {
    NoteDocuments,
    NoteText,
    PageHeadingInfo,
    TextBoxTitle,
    TextBox
  },
  data () {
    return {}
  }
}
</script>

<style>
</style>
